import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultDlpConfig, getDlpTemplateConfig } from './cfg.dlp.default'; //   getTargetProperty,

const cfg = {
  policyType: 82,
  policySubType: 0,
  holderType: 2,
};

export function getDlpExchangeInboundTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined
) {
  const ntfI18nReplaceKeys = [
    'policy.policyTemplate.EX.tmDpfilters.notification.ntfAdminMessage',
    'policy.policyTemplate.EX.tmDpfilters.notification.ntfAdminSubject',
    'policy.policyTemplate.EX.tmDpfilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.EX.tmDpfilters.notification.ntfInternalRecipientSubject',
  ];
  const tempConfig = getDefaultDlpConfig();
  merge(tempConfig, cfg);
  return getDlpTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    [],
    ntfI18nReplaceKeys
  );
}
